//打开PDF
export function openPdfUrl(url) {
	const link = document.createElement('a')
	link.href = url
	link.target = '_blank'
	document.body.appendChild(link)
	link.click()
	window.setTimeout(function () {
		document.body.removeChild(link)
	}, 0)
}
